const httpConfig = {
    baseURL: "https://wallet.hammerchain.io/",
    baseHDURL: "https://wallet-hd.hammermining.com/hdWallets/",
    //baseURL: "/api",
    timeout: 15 * 1000, // Timeout
    //withCredentials: true, // Check cross-site Access-Control
}
export default httpConfig
